<app-header></app-header>
<ion-content>
  <div id="wrapper">
    <ion-grid [fixed]="true">
      <div class="header-section">
        <div
          class="header-section-top"
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
        >
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          <ion-button
            class="btn-download"
            data-cy="download-order-button"
            fill="clear"
            (click)="downloadImportOrderValidation()"
            *ngIf="allowDownloadOption()"
          >
            <ion-icon name="download-outline"></ion-icon>
            {{ 'i18n.orderPage.download' | translate }}
          </ion-button>
        </div>

        <h1>
          {{'i18n.importOrderPage.title' | translate}}

          <span *ngIf="(platformService?.isTouchExperience$ | async) === true">
            <ion-button
              class="btn-download"
              data-cy="download-order-button"
              fill="clear"
              (click)="downloadImportOrderValidation()"
              *ngIf="allowDownloadOption()"
            >
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.orderPage.download' | translate }}
            </ion-button>
          </span>
        </h1>
        <p *ngIf="!!invalidOrdersCounter">
          {{'i18n.importOrderPage.resolveOrderMessage' | translate}}
        </p>
      </div>

      <ion-row>
        <ng-template #RightRailContainer>
          <ion-card class="right-rail-container">
            <div class="right-rail-title">
              {{'i18n.importOrderPage.importStatus' | translate}}
            </div>

            <div class="status-amount">
              <div>
                <div class="right-rail-subtitle">
                  {{'i18n.importOrderPage.validOrders' | translate}}
                </div>
                <div class="amount">{{ validOrdersCounter }}</div>
              </div>

              <div>
                <div class="right-rail-subtitle">
                  {{'i18n.importOrderPage.invalidOrders' | translate}}
                </div>
                <div class="amount red-text">{{ invalidOrdersCounter }}</div>
              </div>
            </div>

            <div class="status-amount">
              <div>
                <div class="right-rail-subtitle">
                  {{'i18n.importOrderPage.validProducts' | translate}}
                </div>
                <div class="amount">{{ validProductsCounter }}</div>
              </div>

              <div>
                <div class="right-rail-subtitle">
                  {{'i18n.importOrderPage.invalidProducts' | translate}}
                </div>
                <div class="amount red-text">{{ invalidProductsCounter }}</div>
              </div>
            </div>
            <ion-button
              [class]="!isSubmitAllowed ? 'usf-fill-disabled-button' : 'usf-fill-green-button'"
              [disabled]="!isSubmitAllowed || (loading$ | async)"
              (click)="confirmSubmitImport()"
            >
              {{'i18n.importOrderPage.submit' | translate}}
            </ion-button>
            <ion-button
              class="usf-outline-orange-button"
              (click)="confirmCancel()"
            >
              {{'i18n.importOrderPage.cancelImport' | translate}}
            </ion-button>
          </ion-card>
        </ng-template>
        <ion-col
          id="mobile-wrapper"
          size-xl="8"
          size-l="8"
          size-md="8"
          size-s="7"
          size-xs="12"
        >
          <div id="mobile-right-rail-container">
            <ng-template [ngTemplateOutlet]="RightRailContainer"></ng-template>
          </div>
          <div
            *ngIf="!!invalidOrders && invalidOrdersCounter > 0"
            class="invalid-orders-wrapper"
          >
            <div class="invalid-orders-header">
              <div>
                {{'i18n.importOrderPage.invalidOrders' | translate}}
                <span class="oval-background-red"
                  >{{ invalidOrdersCounter || 0 }}</span
                >
              </div>
              <ion-button
                *ngIf="invalidOrdersCounter"
                class="usf-green-link-button"
                (click)="toggleOrderSection(1)"
              >
                {{ (isInvalidOrderSectionOpen === true ? 'i18n.common.viewLess'
                : 'i18n.common.viewMore') | translate }}
              </ion-button>
            </div>

            <ng-container *ngIf="isInvalidOrderSectionOpen">
              <ng-container
                *ngFor="let order of invalidOrders; let otIdx = index"
              >
                <div *ngIf="!!order" class="customer-information">
                  <div
                    *ngIf="getCustomerInfo( order.customerNumber, otIdx ) as cust"
                  >
                    <div class="customer-information-dropdown">
                      <div
                        class="customer-name"
                        [class.red-text]="order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_101 ||
                                          order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_104 ||
                                          order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_105"
                      >
                        {{ cust.customerName }} ({{ order.customerNumber }})
                      </div>
                      <div
                        *ngIf=" order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_104 ||
                                order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_105 ||
                                order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_106 ||
                                !!cust.departments?.length"
                        class="select-dropdown-wrapper"
                      >
                        <ion-button
                          [class.usf-outline-green-button]="
                            order.orderHeaderErrorCode !== enumTypes.CRITICAL_ERROR_104 &&
                            order.orderHeaderErrorCode !== enumTypes.CRITICAL_ERROR_105 &&
                            order.orderHeaderErrorCode !== enumTypes.CRITICAL_ERROR_106"
                          [class.usf-outline-orange-button]="
                            order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_104 ||
                            order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_105"
                          [class.usf-fill-disabled-button]="
                            order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_106"
                          (click)="order.orderHeaderErrorCode !== enumTypes.CRITICAL_ERROR_106 && openSelectionModal(otIdx, false, $event)"
                        >
                          {{ getCustomerDepartmentName( order.customerNumber,
                          order.departmentNumber ) }}
                          <ion-icon name="chevron-down-outline"></ion-icon>
                        </ion-button>
                      </div>
                    </div>
                    <span
                      *ngIf="willSplit(otIdx, false)"
                      class="will-split-text red-text"
                    >
                      {{'i18n.importOrderPage.orderWillSplit' | translate}}
                    </span>
                    <div class="order-info">
                      {{'i18n.importOrderPage.po' | translate}} {{
                      order.purchaseOrderNumber }}
                      <span class="mini-border">|</span>
                      {{'i18n.importOrderPage.delivery' | translate}}
                      <ng-container *ngIf="isAbleToOrdering(order)">
                        <a
                          class="usf-green-link-button calendar-button"
                          [class.disabled]="criticalErrors.includes(order.orderHeaderErrorCode)"
                          data-cy="change-date-button"
                          (click)="!criticalErrors.includes(order.orderHeaderErrorCode) && presentCalendarPopover($event, otIdx)"
                        >
                          {{order.confirmedDeliveryDate | date: 'M/d/yyyy':'GMT'
                          }}
                        </a>
                      </ng-container>
                      <span
                        *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
                        class="mini-border"
                        >|</span
                      >
                      <br
                        *ngIf="platformService?.platformType !== platformService?.platformEnum.desktop"
                      />
                      {{'i18n.importOrderPage.products' | translate}}
                      <span class="totalProducts"
                        >{{getTotalUnits(otIdx) }} CS</span
                      >
                      /
                      <span class="totalProducts"
                        >{{getTotalEaches(otIdx) }} EA</span
                      >
                    </div>
                  </div>

                  <div
                    *ngIf="(platformService?.isTouchExperience$ | async) === false"
                    class="desktop-order-info-buttons"
                  >
                    <ion-button
                      *ngIf="order.orderItems?.length > 0"
                      class="usf-outline-green-button hide-products-button"
                      (click)="changeShowFlagStatusFor(order.clientId)"
                    >
                      {{ (flagsForProducts[order.clientId] ?
                      'i18n.importOrderPage.hideProducts' :
                      'i18n.importOrderPage.showProducts') | translate}}
                    </ion-button>
                    <ion-button
                      class="usf-red-link-button"
                      (click)="confirmRemove(otIdx, -1)"
                    >
                      {{'i18n.importOrderPage.deleteOrder' | translate}}
                    </ion-button>
                  </div>
                </div>

                <div
                  *ngIf="!!order && (platformService?.isTouchExperience$ | async) === true"
                  class="tablet-product-buttons"
                >
                  <ion-button
                    *ngIf="order.orderItems?.length > 0"
                    class="usf-outline-green-button hide-products-button"
                    (click)="changeShowFlagStatusFor(order.clientId)"
                  >
                    {{ (flagsForProducts[order.clientId] ?
                    'i18n.importOrderPage.hideProducts' :
                    'i18n.importOrderPage.showProducts') | translate}}
                  </ion-button>
                  <ion-button
                    class="usf-red-link-button"
                    (click)="confirmRemove(otIdx, -1)"
                  >
                    {{'i18n.importOrderPage.deleteOrder' | translate}}
                  </ion-button>
                </div>

                <ng-container *ngIf="!!order">
                  <app-import-order-validation-product
                    *ngFor="let orderItem of order.orderItems; let oiIdx = index"
                    [hidden]="!flagsForProducts[order.clientId]"
                    [orderItem]="orderItem"
                    [showSubstitute]="!!substitutesForInvalidOrders.get(otIdx) && (substitutesForInvalidOrders.get(otIdx)?.indexOf(oiIdx) > -1)"
                    [orderHeaderErrorCode]="order.orderHeaderErrorCode"
                    [orderHeaderErrorMsg]="order.orderHeaderErrorMsg"
                    (removeEmitter)="confirmRemove(otIdx, oiIdx)"
                    (quantityEmitter)="updateQuantity(otIdx, oiIdx, false, $event)"
                    (substituteEmitter)="showSubstituteFor(otIdx, oiIdx, false)"
                    (replaceEmitter)="replaceOriginalWithSubstitute(otIdx, oiIdx, false)"
                  >
                  </app-import-order-validation-product>
                </ng-container>

                <span *ngIf="!!order" class="divider-bottom"></span>
              </ng-container>
            </ng-container>
          </div>

          <div *ngIf="!!validOrders" class="valid-orders-wrapper">
            <div class="valid-orders-header">
              <div>
                {{'i18n.importOrderPage.validOrders' | translate}}
                <span class="oval-background-green"
                  >{{ validOrdersCounter || 0 }}</span
                >
              </div>
              <ion-button
                *ngIf="validOrdersCounter"
                class="usf-green-link-button"
                (click)="toggleOrderSection(2)"
              >
                {{ (isValidOrderSectionOpen === true ? 'i18n.common.viewLess' :
                'i18n.common.viewMore') | translate }}
              </ion-button>
            </div>

            <ng-container *ngIf="isValidOrderSectionOpen">
              <ng-container
                *ngFor="let order of validOrders; let otIdx = index"
              >
                <div *ngIf="!!order" class="customer-information">
                  <div *ngIf="getCustomerInfo( order.customerNumber ) as cust">
                    <div class="customer-information-dropdown">
                      <div class="customer-name">
                        {{ cust.customerName }} ({{ order.customerNumber }})
                      </div>
                      <div
                        *ngIf="!!cust.departments?.length"
                        class="select-dropdown-wrapper"
                      >
                        <ion-button
                          [class]="order.orderHeaderErrorCode === enumTypes.CRITICAL_ERROR_105 ?
                                    'usf-outline-orange-button' : 'usf-outline-green-button' "
                          (click)="openSelectionModal(otIdx, true, $event)"
                          >{{ getCustomerDepartmentName( order.customerNumber,
                          order.departmentNumber ) }}
                          <ion-icon name="chevron-down-outline"></ion-icon>
                        </ion-button>
                      </div>
                    </div>
                    <span
                      *ngIf="willSplit(otIdx, true)"
                      class="will-split-text red-text"
                    >
                      {{'i18n.importOrderPage.orderWillSplit' | translate}}
                    </span>
                    <div>
                      {{'i18n.importOrderPage.po' | translate}} {{
                      order.purchaseOrderNumber }}
                      <span class="mini-border">|</span>
                      {{'i18n.importOrderPage.delivery' | translate}}
                      <ng-container *ngIf="isAbleToOrdering(order)">
                        <a
                          class="usf-green-link-button calendar-button"
                          [class.disabled]="criticalErrors.includes(order.orderHeaderErrorCode)"
                          data-cy="change-date-button"
                          (click)="!criticalErrors.includes(order.orderHeaderErrorCode) && presentCalendarPopover($event, otIdx, true)"
                        >
                          {{order.confirmedDeliveryDate | date: 'M/d/yyyy':'GMT'
                          }}
                        </a>
                      </ng-container>
                      <span
                        *ngIf="platformService?.platformType === platformService.platformEnum.desktop"
                        class="mini-border"
                        >|</span
                      >
                      <br
                        *ngIf="platformService?.platformType !== platformService.platformEnum.desktop"
                      />
                      {{'i18n.importOrderPage.products' | translate}}
                      <span class="totalProducts"
                        >{{getTotalUnits(otIdx, true) }} CS</span
                      >
                      /
                      <span class="totalProducts"
                        >{{getTotalEaches(otIdx, true) }} EA</span
                      >
                    </div>
                  </div>

                  <div
                    *ngIf="(platformService?.isTouchExperience$ | async) === false"
                    class="desktop-order-info-buttons"
                  >
                    <ion-button
                      *ngIf="order.orderItems?.length > 0"
                      class="usf-outline-green-button hide-products-button"
                      (click)="changeShowFlagStatusFor(order.clientId)"
                    >
                      {{ (flagsForProducts[order.clientId] ?
                      'i18n.importOrderPage.hideProducts' :
                      'i18n.importOrderPage.showProducts') | translate}}
                    </ion-button>
                    <ion-button
                      class="usf-red-link-button"
                      (click)="confirmRemove(otIdx, -1, true)"
                    >
                      {{'i18n.importOrderPage.deleteOrder' | translate}}
                    </ion-button>
                  </div>
                </div>

                <div
                  class="tablet-product-buttons"
                  *ngIf="!!order && (platformService?.isTouchExperience$ | async) === true"
                >
                  <ion-button
                    *ngIf="order.orderItems?.length > 0"
                    class="usf-outline-green-button hide-products-button"
                    (click)="changeShowFlagStatusFor(order.clientId)"
                  >
                    {{ (flagsForProducts[order.clientId] ?
                    'i18n.importOrderPage.hideProducts' :
                    'i18n.importOrderPage.showProducts') | translate}}
                  </ion-button>
                  <ion-button
                    class="usf-red-link-button"
                    (click)="confirmRemove(otIdx, -1, true)"
                  >
                    {{'i18n.importOrderPage.deleteOrder' | translate}}
                  </ion-button>
                </div>

                <ng-container *ngIf="!!order">
                  <app-import-order-validation-product
                    *ngFor="let orderItem of order.orderItems; let oiIdx = index"
                    [hidden]="!flagsForProducts[order.clientId]"
                    [orderItem]="orderItem"
                    [showSubstitute]="!!substitutesForValidOrders.get(otIdx) && (substitutesForValidOrders.get(otIdx)?.indexOf(oiIdx) > -1)"
                    [orderHeaderErrorCode]="order.orderHeaderErrorCode"
                    [orderHeaderErrorMsg]="order.orderHeaderErrorMsg"
                    (removeEmitter)="confirmRemove(otIdx, oiIdx, true)"
                    (quantityEmitter)="updateQuantity(otIdx, oiIdx, true, $event)"
                    (substituteEmitter)="showSubstituteFor(otIdx, oiIdx, true)"
                    (replaceEmitter)="replaceOriginalWithSubstitute(otIdx, oiIdx, true)"
                  >
                  </app-import-order-validation-product>
                </ng-container>

                <span *ngIf="!!order" class="divider-bottom"></span>
              </ng-container>
            </ng-container>
          </div>
        </ion-col>
        <ion-col
          id="desktop-tablet-only"
          size-xl="3"
          size-l="3"
          size-md="4"
          size-s="5"
          size-xs="5"
          offset-xl="1"
          offset-md="0"
        >
          <ng-template [ngTemplateOutlet]="RightRailContainer"></ng-template>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <app-footer></app-footer>
</ion-content>

<div data-cy="order-validation-top-button-section" class="scroll-to-top-button">
  <ion-button
    data-cy="order-validation-top-button"
    class="usf-fill-green-button"
    (click)="goToTop()"
  >
    {{ 'i18n.common.top' | translate }}&nbsp;
    <ion-icon
      data-cy="order-validation-top-button-icon"
      name="chevron-up"
    ></ion-icon>
  </ion-button>
</div>
